import { render } from "./PrivacyPolicyView.vue?vue&type=template&id=6627d389&scoped=true"
const script = {}

import "./PrivacyPolicyView.vue?vue&type=style&index=0&id=6627d389&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6627d389"]])

export default __exports__